(() => {
  function initializeMenus() {
    document.querySelectorAll('[data-queen-mobile-menu]').forEach(menu => {
      if (menu.dataset.initialized) return;
      menu.dataset.initialized = 'true';
      const summary = menu.querySelector('summary');
      const nav = menu.querySelector('nav');
      const close = () => { menu.open = false; summary.focus(); };
      menu.querySelector('.qn-mobile-menu-backdrop').addEventListener('click', close);
      menu.addEventListener('toggle', () => {
        document.documentElement.classList.toggle('qn-mobile-menu-open', menu.open);
        if (menu.open) nav.querySelector('a')?.focus();
      });
      menu.addEventListener('keydown', event => {
        if (!menu.open) return;
        if (event.key === 'Escape') { event.preventDefault(); close(); }
        if (event.key === 'Tab') {
          const links = [...nav.querySelectorAll('a')];
          if (event.shiftKey && document.activeElement === links[0]) { event.preventDefault(); links.at(-1).focus(); }
          else if (!event.shiftKey && document.activeElement === links.at(-1)) { event.preventDefault(); links[0].focus(); }
        }
      });
    });
  }
  /*
    Hover intent for the desktop dropdowns.

    The panels open and close on :hover alone - this only marks the bar as
    "hot" once a panel has been open long enough to be deliberate. Hot means
    queen-nav.css swaps panels on a single frame instead of easing each one
    in, which is what keeps a swap from going translucent mid-crossfade.

    The class comes off the moment the pointer leaves the bar, so the last
    panel fades out on the slower timings rather than snapping shut.
  */
  const WARM_UP = 150;

  function preloadMegaBackgrounds(nav) {
    nav.querySelectorAll('.mega_menu > .dropdown-menu').forEach(panel => {
      const url = panel.style.backgroundImage;
      if (!url || url === 'none') return;
      const image = new Image();
      image.src = url.slice(url.indexOf('(') + 1, url.lastIndexOf(')')).replace(/['"]/g, '');
    });
  }

  function initializeHoverIntent() {
    document.querySelectorAll('#header.style_2 .navbar .nav').forEach(nav => {
      if (nav.dataset.hoverIntent) return;
      nav.dataset.hoverIntent = 'true';

      let warm = null;
      let preloaded = false;

      nav.addEventListener('pointerover', event => {
        /*
          The panels are display:none until opened, so their background images
          are not fetched until then - a panel opening for the first time would
          otherwise flash white before its image arrives. Touching the bar is
          enough warning to go and get them.
        */
        if (!preloaded) {
          preloaded = true;
          preloadMegaBackgrounds(nav);
        }

        if (!event.target.closest('.dropdown-parent')) return;
        if (warm || nav.classList.contains('qn-nav-hot')) return;
        warm = setTimeout(() => {
          warm = null;
          nav.classList.add('qn-nav-hot');
        }, WARM_UP);
      });

      nav.addEventListener('pointerleave', () => {
        clearTimeout(warm);
        warm = null;
        nav.classList.remove('qn-nav-hot');
      });
    });
  }

  initializeMenus();
  initializeHoverIntent();
  document.addEventListener('shopify:section:load', () => {
    initializeMenus();
    initializeHoverIntent();
  });
})();
